import { InlineSvg } from 'components/svg';
import { FC, useEffect } from 'react';

type Props = {
  title: string | undefined;
  message: string | undefined;
  onConfirm: () => void;
  onCancel: () => void;
  isSubmitting?: boolean;
  hideConfirmBtn?: boolean;
};

const ConfirmationModal: FC<Props> = ({ title, message, onConfirm, onCancel, isSubmitting, hideConfirmBtn }) => {
  useEffect(() => {
    document.body.classList.add('modal-open');
    return () => {
      document.body.classList.remove('modal-open');
    };
  }, []);

  return (
    <>
      <div className="modal fade show d-block" id="kt_modal_confirm" role="dialog" tabIndex={-1} aria-modal="true">
        <div className="modal-dialog modal-dialog-centered modal-md">
          <div className="modal-content">
            <div className="modal-header">
              <h2 className="fw-bolder">{title}</h2>
              <div
                className="btn btn-icon btn-sm btn-active-icon-primary"
                data-kt-confirm-modal-action="close"
                onClick={() => onCancel()}
                style={{ cursor: 'pointer' }}
              >
                <InlineSvg path="/media/icons/duotune/arrows/arr061.svg" className="svg-icon-1" />
              </div>
            </div>
            <div className="modal-body  mx-2 pt-0">
              <div className="container pe-0 ps-0">
                <div className="row">
                  <div className="col-12 pb-7 pt-4 fw-bold fs-3">{message}</div>
                </div>
                <div className="row">
                  <div className="col-12">
                    <div className="d-flex justify-content-left">
                      {!hideConfirmBtn && (
                        <button className="btn btn-primary me-5" onClick={() => onConfirm()} disabled={isSubmitting}>
                          Confirm
                        </button>
                      )}
                      <button onClick={() => onCancel()} className="btn btn-light-primary me-5">
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show"></div>
    </>
  );
};

export { ConfirmationModal };
